let clothes = {
  shorts: {
    placed: false
  },
  shirt: {
    placed: false,
    vo: "round1/vo_shirt"
  },
  sandals: {
    placed: false,
    vo: "round1/vo_sandals"
  },
  hat: {
    placed: false,
    vo: "round1/vo_hat"
  },
  sunglasses: {
    placed: false,
    vo: "round1/vo_sunglasses"
  },
  jetpack: {
    placed: false,
    vo: "round1/vo_jetpack"
  }
}

export {clothes}
